class LoggedIn {
    public element: HTMLElement;
    public status: Boolean;
    public redirectUrl: string = '';

    bindings() {
        this.status = this.element.dataset.status == '1' ? true : false;
        if (this.status == true) {
            // Body class
            document.body.classList.add('is-user');

            this.modifyModalLinks();
        }
        else {
          document.body.classList.add('not-user');
        }

        this.redirectUrl = this.element.dataset.redirectUrl ?? '';
        if (this.redirectUrl != '') {
          this.setCookie('GeoMateRedirectOverride', '1', 30);
          const forceLangIsos: Record<string, string> = {
            FORCE_DE: 'de-DE',
            FORCE_EN: 'en-US',
            FORCE_CH: 'de-CH',
            FORCE_AE: 'en-AE',
            FORCE_FR_CH: 'fr-CH',
          };
          const forceLangIso = forceLangIsos[this.redirectUrl];
          if (forceLangIso) {
            const target = document.querySelector(`.js-site-link[data-langiso="${forceLangIso}"]`) as HTMLInputElement | null;
            // Without a target the placeholder would be followed as a relative path and 404
            if (!target || target.value == '') {
              return;
            }
            this.redirectUrl = target.value;
          }

          if (window.location.search != '') {
            if (this.redirectUrl.includes('?')) {
              this.redirectUrl = this.redirectUrl + window.location.search.replace('?', '&');
            }
            else {
              this.redirectUrl = this.redirectUrl + window.location.search;
            }
          }

          window.location.href= `${this.redirectUrl}`;
        }
    }

    cache() {
      this.element = document.querySelector('.logged-in-cmp') as HTMLElement;
    }

    init() {
      this.cache();
      this.bindings();
    }

    setCookie(cName: string, cValue: string, expDays: number) {
      let date = new Date();
      date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
    }

    public modifyModalLinks() {
        if (this.status !== true) {
            return
        }

        // Replace popup target email if loggedin at e.g. downloads
        const targetEmailPopupEls = document.querySelectorAll('[data-target=popup-email]') as NodeListOf<HTMLElement>;
        targetEmailPopupEls.forEach((el) => {
            el.dataset.target = 'none';
            el.dataset.toggle = 'none';
        });

        const mainElements = Array.from(document.querySelectorAll('[data-download-id]'));
        const shadowElements = document.querySelector('atelier-layout')?.shadowRoot?.querySelectorAll('[data-download-id]');
        const targetDownloadModalEls = [
            ...mainElements,
            ...(shadowElements ? Array.from(shadowElements) : [])
        ] as HTMLElement[]

        targetDownloadModalEls.forEach((el) => {
            if (el.dataset.target === 'none' && el.dataset.toggle === 'none') {
                // on atelier sites, this gets called twice for links in the light dom,
                // so we can return early if this link has been modified previously
                return
            }

            el.dataset.target = 'none';
            el.dataset.toggle = 'none';

            el.addEventListener('click', () => {
                const apiBaseUrl = document.body.dataset.apiBaseUrl;
                const idFile = el.dataset.downloadId;
                const slugFile = el.dataset.downloadSlug;
                const lang = document.documentElement.lang.slice(0, 2);
                const directDownloadUrl = apiBaseUrl + 'download/' + slugFile + '?lang=' + lang;
                // @ts-ignore
                const newWindow = window.open(directDownloadUrl, '_blank');
                // @ts-ignore
                newWindow.focus();
            });
        });
    }
  }

  export default LoggedIn;
